import React from 'react'
import Banner from './Banner';
import About from './About';
import Services from './Services';
import Work from './Work';
import Contact from './Contact';
import Footer from './Footer';


const Home = () => {
  return (

    <div id='home' className='bg-site bg-no-repeat bg-cover overflow-hidden'>

      <Banner />
      <About />
      <Services />
      <Work />
      <Contact />
      <Footer />
    </div>
  )
}

export default Home
